import React, { useEffect } from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { Formik, Form } from "formik";
import cogoToast from "cogo-toast";
import * as Yup from "yup";
import { useCreateMaintenanceFeeMutation, useGetMaintenanceFeeSettingsQuery } from "../../../../../redux/apiSlice";
import TextInput from "../../../Common/components/text-input";
import SelectInput from "../../../Common/components/select-input";


const FeeModal = ({ showViewFeeModal, onHide, details}) => {

    const [
        createMaintenanceFee,
    ] = useCreateMaintenanceFeeMutation();
    const validationSchema = Yup.object({
        fee: Yup.number().min(0.1).required('Required'),
    });

    const { data: maintenanceFeeSettings, isLoading: isFetchingSettings } = useGetMaintenanceFeeSettingsQuery(details.value);

    return (
        <Modal
            show={showViewFeeModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Formik
                initialValues={{
                    fee: isFetchingSettings ? 0 : maintenanceFeeSettings?.data?.fee || 0,
                    exemptionConditions: {
                        minimumTrades: isFetchingSettings ? 0 : maintenanceFeeSettings?.data?.exemptionConditions?.minimumTrades || 0,
                        minimumTradeValue: isFetchingSettings ? 0 : maintenanceFeeSettings?.data?.exemptionConditions?.minimumTradeValue || 0,
                    },
                    frequency: isFetchingSettings ? "" : maintenanceFeeSettings?.data?.frequency,
                    partner: details.value,
                    enabled: isFetchingSettings ? "true" : maintenanceFeeSettings?.data?.enabled.toString() || "true"

                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    const convertedValues = {
                        ...values,
                        enabled: values.enabled === "true" || values.enabled === true
                    };
                
                    createMaintenanceFee(convertedValues)
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Maintenance Fee Settings Updated Successfully");
                            onHide();
                        });
                }}        
            >
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Maintenance Fee
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>

                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                        <FormLayout.Row>
                            <TextInput
                                label="Maintenance Fee"
                                name="fee"
                                type="number"
                                min="0.0"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Minimum Trades"
                                name="exemptionConditions.minimumTrades"
                                type="number"
                                min="0.0"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Minimum Trade Value"
                                name="exemptionConditions.minimumTradeValue"
                                type="number"
                                min="0.0"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Partner"
                                name="partner"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <SelectInput
                                label="Frequency"
                                name="frequency"
                                options={["YEARLY", "MONTHLY"]}
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <SelectInput
                                label="Enabled"
                                name="enabled"
                                options={["true", "false"]}
                            />
                        </FormLayout.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Update
                        </button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal >
    );
}

export default FeeModal;
